
// src/connects/notifications-page.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import AnnouncesUnread from '../actions/announce-unread-flag'

export const mapStateToProps = (state, ownProps)=> {
  const group_id = ownProps.params.group_id
  const latest = state.announce.latest
  const close = state.announce.close
  const user = state.user.current
  return {
    group_id,
    latest,
    close,
    user,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willUpdate: (props, nextProps) => {
       /* お知らせタブから通知タブの切り替わったタイミングで条件が通る */
      if(props.ui.tabIndex == 1 && nextProps.ui.tabIndex == 0){
        if(nextProps.user && nextProps.latest && (!nextProps.user.announce_last_seen_at || nextProps.user.announce_last_seen_at < nextProps.latest)) {
          dispatch(actions.saveAnnounceLastSeenTime(nextProps.latest))
          dispatch(actions.closeAnnounce())
        }
      }
    },
    willUnmount: (props) => {
      /* 新着の通知ページ内のお知らせタブにいる状態でページを閉じた時、nextProps.user.announce_last_seen_atがnullか、announce_last_seen_atがlatestより過去の場合はannounce_last_seen_atを更新させる */
      if(props.ui.tabIndex == 1 && props.user && props.latest && (!props.user.announce_last_seen_at || props.user.announce_last_seen_at < props.latest)) {
        dispatch(actions.saveAnnounceLastSeenTime(props.latest))
        dispatch(actions.closeAnnounce())
      }
    },
    openNotificationrSettingsPage: ()=> dispatch(actions.openUserSettingsPage("notification")),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      tabIndex: (props)=> props.params && props.params.tabIndex || 0
    }
  }),
  lifecycle,
  translate(),
  trackPage('notifications'),
)



// WEBPACK FOOTER //
// ./src/connects/notifications-page.js